<template>
    <main>
        <div>
            Properties page is working!
        </div>
    </main>
</template>

<script>
export default {}
</script>

<style scoped></style>